import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';
export function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cg-cookie-consent');
    if (!consent) {
      // Small delay for smoother entrance animation
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);
  const handleAccept = () => {
    localStorage.setItem('cg-cookie-consent', 'accepted');
    setIsVisible(false);
  };
  const handleReject = () => {
    localStorage.setItem('cg-cookie-consent', 'rejected');
    setIsVisible(false);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom duration-500" data-id="element-77">
      <div className="max-w-7xl mx-auto bg-navy-900 border border-white/10 shadow-2xl rounded-sm p-6 md:p-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-6" data-id="element-78">
        <div className="flex items-start gap-4 max-w-2xl" data-id="element-79">
          <div className="bg-navy-800 p-2 rounded-full text-cg-orange-600 hidden sm:block" data-id="element-80">
            <Cookie className="w-5 h-5" data-id="element-81" />
          </div>
          <div data-id="element-82">
            <h3 className="text-white font-bold text-sm mb-1" data-id="element-83">
              We value your privacy
            </h3>
            <p className="text-steel-300 text-xs leading-relaxed" data-id="element-84">
              We use cookies to enhance your browsing experience, serve
              personalised content, and analyse our traffic. By clicking "Accept
              All", you consent to our use of cookies. Read our{' '}
              <Link to="/cookie-policy" className="text-cg-orange-600 hover:text-white underline decoration-cg-orange-600/30 underline-offset-2 transition-colors" data-id="element-85">
                Cookie Policy
              </Link>
              .
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto flex-shrink-0" data-id="element-86">
          <button onClick={handleReject} className="px-4 py-2.5 border border-white/20 text-white text-xs font-bold uppercase tracking-wider rounded-sm hover:bg-white/5 transition-colors whitespace-nowrap text-center" data-id="element-87">
            Reject Optional
          </button>
          <button onClick={handleAccept} className="px-6 py-2.5 bg-cg-orange-600 text-white text-xs font-bold uppercase tracking-wider rounded-sm hover:bg-cg-orange-500 transition-colors whitespace-nowrap text-center shadow-lg shadow-cg-orange-900/20" data-id="element-88">
            Accept All
          </button>
        </div>
      </div>
    </div>;
}